import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        const id = decodeURIComponent(hash.replace(/^#/, ''));
        if (!id) {
            window.scrollTo(0, 0);
            return;
        }

        let cancelled = false;
        let attempts = 0;
        let timer = 0;

        const scrollToSection = () => {
            if (cancelled) return;
            const section = document.getElementById(id);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }
            attempts += 1;
            if (attempts < 30) {
                timer = window.setTimeout(scrollToSection, 100);
            }
        };

        timer = window.setTimeout(scrollToSection, 0);
        return () => {
            cancelled = true;
            window.clearTimeout(timer);
        };
    }, [pathname, hash]);

    useEffect(() => {
        if (typeof window.fbq === 'function') {
            window.fbq?.('track', 'PageView');
        }
    }, [pathname]);

    return null;
};

export default ScrollToTop;
